/*

ashraf 10/16/2022  2700524332  added code comments in search, add role management.
Raghu 10/26/2022 2700524332 Input Field Alignment & Enhancements.
Akhlaque 10/26/2022 2700524332 renamed clear button to reset
Raghu 10/28/2022 2700524332 Card Stylings and Inputfields alignment fixes
Lalitha 10/26/2022 2700524332 renamed clear button to reset
Prakash 11/03/2022 2700524332 Added New card class for fields.
Akhila 12/08/2022 2700524332 added session storage for search items
Sohel 12/12/2022 2700524332 Implemented Copy Functionality
kavya9reddy 12/12/2022 2700524332 Added Status dropdown field.
Sai Maheshwar 12/14/2022 3031450488 added save close for add user
Sohel 12/14/2022 3031450488 fixed button alignment issue
Raghu 12/14/2022 3031450488 fixed field alignment issue
Ashraf 12/19/2022 3031450488 fixed company code dropdown values issue
Suresh Peddavoora 12/21/2022 3031450488 Fixed Multiselect Dropdown Alignment Issue
Dilip 12/22/2022 3031450488 bugFix session stoarge
Dilip 12/27/2022 3031450488 bugFix module autocomplete
Prakash 12/27/2022 3031450488 fixed alignments issue for inputfield.
Raghu 12/30/2022 3031450488 fixed alignment for company code.
Dilip 01/05/2023  3031450488 fixed dropdown issues
Dilip 01/10/2023  3031450488 fixed module dropdown issues
Rohini 02/16/2023 3031450488 fixed module alignments issue in add role
suresh peddavoora 02/24/2023 3031450488 New UI changes added
suresh peddavoora 02/27/2023 3031450488 New UI changes
suresh peddavoora 03/01/2023 3031450488 New UI changes
suresh peddavoora 03/02/2023 3031450488 responsive fields changes
suresh peddavoora 03/03/2023 3031450488 responsive fields changes
suresh peddavoora 03/14/2023 3031450488 Tables and fields alignments
suresh peddavoora 03/15/2023 3031450488 responsive fields alignment fixes
Prakash  03/15/2023 3031450488 fixed alignments issue in responsive
suresh peddavoora 04/06/2023 3031450488 field alignments fixes
Prakash  14-04-2023 3031450488 fixed alignments issue in responsive
Ravi  05/04/2023 3031450488 changed status bydefault to Active
Sohel 05/23/2023 2700539021 removed Module Field
Prakash 26-05-2023 2700539021 fixed button issue in tab view.
Prakash 03-06-2023 2700539021 fixed button issue in tab view.
Sohel 12/11/2023 2700539021 Added Role Name  and description field validation changes and case insenstive.

*/

import {
  Grid,
  Button,
  TextField,
  Checkbox,
} from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {Form, Formik} from 'formik';
import React, {useEffect, useState, useContext, useRef} from 'react';
import {resetData, getDropDownData} from '../../../redux/reducers/RoleManagement/AddRole';
import {useDispatch, useSelector} from 'react-redux';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import RoleManagementTable from './RoleManagementTable';
import {ThemeContext} from '../../../themes/ThemeProvider';
import DialogBox from '../../../components/DialogBox';
import AddWindow from './AddWindow';
import {getOptions} from '../../../util/GetDropDownOptions';
import {COMPANY_TYPE} from '../../../constants/Lookup';
import {getCompanyCode} from '../../../redux/reducers/LetterMaintainance/AddLetterData';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {filteredCheckedData, tempSelectFunc} from '../../../util/Functions';
import {getAllReportCreatedForData} from '../../../redux/reducers/ReportMaster';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

// search role form, table component render (2700524332)
const SearchRoleManagement = ({
  setValue = () => {},
  setRecordFormatCode,
  setRoleId,
  setModuleNames = () => {},
  isCopy = false,
  setIsCopy = () => {},
  isAddUser = false,
  tempSelectedRows,
  setTempSelectedRows,
  handleClose,
  selectedRows,
  setSelectedRows,
  company,
  setDeletedIds,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {companyCodeData} = useSelector(({addLetterData}) => addLetterData);
  const classes = reusableInputStyles();

  const searchSessionRoleManagement = JSON.parse(sessionStorage.getItem('searchRoleManagement'));

  const StatusOptions = [
    {key: 'A', value: 'All'},
    {key: 'Y', value: 'Active'},
    {key: 'N', value: 'InActive'},
  ];
  // initial values of search form (2700524332)
  const initialValues = {
    roleName: '',
    roleDescription: '',
    windowName: '',
    module: [],
    isActive: {key: 'Y', value: 'Active'},
    companyCode: [],
  };
  const dispatch = useDispatch();

  // reset redux data of fetched role data (2700524332)
  useEffect(() => {
    dispatch(resetData());
  }, []);

  const [submit, setSubmit] = useState(false);
  const [searchData, setSearchData] = useState(false);
  const tempUnCheckedRef = useRef([]);
  const [openWindow, setOpenWindow] = useState(false);
  const [windowData, setWindowData] = useState('');
  const [editWindow, setEditWindow] = useState(false);
  const [windowRowData, setWindowRowData] = useState('');
  const handleWindowClose = () => {
    setOpenWindow(false);
    setEditWindow(false);
  };

  // search data submission (2700524332)
  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchData(data);
    if (!isAddUser) {
      sessionStorage.setItem('searchRoleManagement', JSON.stringify(data));
    }
  };

  // to fetch module, company code dropdown options (2700524332)
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(getCompanyCode());
    dispatch(getAllReportCreatedForData());
  }, [dispatch]);

  return (
    <div>
      <div className={ isAddUser ? `col-md-12` : `mb-0 ${classes.cardStyleWhite} rounded`}>
        <h2 className="search-title">Role Search</h2>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={searchSessionRoleManagement && !isAddUser ? searchSessionRoleManagement : initialValues}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, touched, handleReset, handleBlur, setFieldValue} = props;

            return (
              <div>
                <Form autoComplete="off">
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid className="form-row standard-field-textfields new-standard-textfields" container spacing={2}>
                        <>
                          <Grid item xs={6} md={6} lg={4} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Role Name`}
                              label="Role Name"
                              className={`${classes.labelName}`}
                              name="roleName"
                              value={values?.roleName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.roleName}
                              fullWidth
                              // role="grid"
                              aria-label="form-label-1"
                              // aria-selected="true"
                            />
                          </Grid>
                          <Grid item xs={6} md={6} lg={4} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Role Description`}
                              label="Role Description"
                              className={`${classes.labelName}`}
                              name="roleDescription"
                              value={values.roleDescription}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                              aria-label="form-label-2"
                            />
                          </Grid>
                          {/* <Grid
                            item
                            xs={6}
                            md={6}
                            lg={4}
                            className={`form-group autocomplete-field ${values.module.length > 2 && `autocomplete-checkbox`}`}

                          >
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                              }}
                              className={`${classes.labelName}`}
                              multiple
                              disableCloseOnSelect
                              name="module"
                              id="module"
                              size="small"
                              limitTags={1}
                              value={values.module}
                              options={getOptions(MODULE, dropDownData)}
                              getOptionSelected={(option, value) =>
                                option.value === value.value
                               }
                              getOptionLabel={(option) => {
                                return option && option.valueCode && option.value
                                  ? option.value
                                  : option.value === null
                                  ? option.valueCode
                                  : option.value;
                              }}
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue("module", value);
                              }}
                              renderOption={(option, { selected }) => (
                                <React.Fragment>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={
                                      <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                    }
                                    checked={selected}
                                    className={classes.checkBox}
                                  />
                                  {option?.value ? option.value : ""}
                                </React.Fragment>
                              )}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                   className={`autocomplete-multiselect-label add-role-fields`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    label="Module"
                                    placeholder="Select Module"
                                    aria-label="form-label-3"
                                  />
                                </div>
                              )}
                            />
                          </Grid> */}
                          <Grid
                            item
                            xs={6}
                            md={6}
                            lg={4}
                            className={`form-group autocomplete-field ${values.companyCode.length > 2 && `autocomplete-checkbox`}`}
                          >
                            <GuiAutoComplete
                              classes={{
                                popper: classes.popper,
                                option: classes.option,
                              }}
                              multiple
                              disableCloseOnSelect
                              limitTags={1}
                              name="companyCode"
                              id="companyCode"
                              size="small"
                              className={`${classes.labelName}`}
                              value={isAddUser ? company : values.companyCode}
                              disabled={isAddUser}
                              options={getOptions(COMPANY_TYPE, companyCodeData).map(
                                (el) => el.value,
                              )}
                              getOptionSelected={(option, value) => option === value}
                              getOptionLabel={(option) => {
                                return option && option ? option : option;
                              }}
                              onChange={(e, value) => {
                                if (value) {
                                  setFieldValue('companyCode', value);
                                } else {
                                  setFieldValue('companyCode', '');
                                }
                              }}
                              renderOption={(option, {selected}) => (
                                <React.Fragment>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={
                                      <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                    }
                                    checked={selected}
                                    className={classes.checkBox}
                                  />
                                  {option ? option : ''}
                                </React.Fragment>
                              )}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    className={`autocomplete-multiselect-label add-role-fields placeholder-filed`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    label="Company Code"
                                    placeholder="Select Company Code"
                                    aria-label="form-label-4"
                                  />
                                </div>
                              )}
                            />
                          </Grid>
                          <Grid item xs={6} md={6} lg={2} className="form-group">
                            <GuiAutoComplete
                              classes={`${{
                                popper: classes.popper,
                                option: classes.option,
                              }}`}
                              name="isActive"
                              id="isActive"
                              size="small"
                              options={StatusOptions}
                              required
                              value={values.isActive}
                              getOptionLabel={(option) => {
                                return option && option?.value;
                              }}
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue('isActive', value);
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    className={`${classes.labelName}`}
                                    variant="outlined"
                                    margin="dense"
                                    // InputLabelProps={{ shrink: true }}
                                    label="Status"
                                    placeholder="Select Status"
                                  />
                                </div>
                              )}
                            />
                          </Grid>

                          <Grid item xs={6} md={ isAddUser ? 6 : 12 } lg={ isAddUser ? 5 : 3 }>
                            <div className= { isAddUser ? `d-flex  justify-content-end mb-3` : `d-flex justify-content-md-center justify-content-lg-start mb-3`} >
                              <Button
                                variant="outlined"
                                className={`reset-btn  mr-1 ${classes.buttonRoot}`}
                                onClick={() => {
                                  handleReset();
                                  setSubmit(true);
                                  setSearchData(initialValues);
                                  sessionStorage.removeItem('searchRoleManagement');
                                }}
                              >
                                Reset
                              </Button>
                              <Button
                                type="submit"
                                variant="outlined"
                                className={`search-btn ml-1  ${classes.buttonRoot}`}
                              >
                                Search
                              </Button>
                            </div>


                          </Grid>
                          {isAddUser && (
                            <Grid item xs={6} md={6} lg={5}>

                              <div className="d-flex  justify-content-md-start justify-content-lg-end  mb-3">
                                <Button
                                  aria-label="close"
                                  variant="outlined"
                                  className={`mr-1 reset-btn ${classes.buttonRoot}`}
                                  onClick={() => {
                                    handleClose();
                                  }}
                                >
                                  Close
                                </Button>
                                <Button
                                  aria-label="save"
                                  variant="outlined"
                                  className={`ml-1 search-btn ${classes.buttonRoot}`}
                                  onClick={() => {
                                    const obj = tempSelectFunc(
                                      'roleName',
                                      '',
                                      tempUnCheckedRef,
                                    );

                                    if (selectedRows) {
                                      const [newSelectedRows, newUnSelectedRows] =
                                        filteredCheckedData(
                                          selectedRows,
                                          obj,
                                          'roleName',
                                          '',
                                        );
                                      const allSelectedRows = [
                                        ...newSelectedRows,
                                        ...tempSelectedRows,
                                      ];
                                      console.log(newUnSelectedRows, 'newUnSelectedRows');
                                      setDeletedIds((prev) => [
                                        ...prev,
                                        newUnSelectedRows?.length > 0 ?
                                          newUnSelectedRows[0]?.roleId :
                                          0,
                                      ]);
                                      // deleteIdRef.current = [
                                      //   ...deleteIdRef.current,
                                      //   newUnSelectedRows?.length > 0
                                      //     ? newUnSelectedRows[0]?.roleId
                                      //     : 0,
                                      // ];
                                      setSelectedRows(allSelectedRows);
                                      setTempSelectedRows([]);
                                      handleClose();
                                    }
                                  }}
                                >
                                  Save
                                </Button>
                              </div>

                            </Grid>
                          )}
                        </>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
                {/* {isLoading && <PageLoader />} */}
              </div>
            );
          }}
        </Formik>
        <Grid>
          <RoleManagementTable
            setRoleId={setRoleId}
            submit={submit}
            searchData={searchData}
            setSubmit={setSubmit}
            setWindowData={setWindowData}
            windowData={windowData}
            setEditWindow={setEditWindow}
            editWindow={editWindow}
            setWindowRowData={setWindowRowData}
            windowRowData={windowRowData}
            setValue={setValue}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            setTempSelectedRows={setTempSelectedRows}
            tempSelectedRows={tempSelectedRows}
            setModuleNames={setModuleNames}
            setIsCopy={setIsCopy}
            isCopy={isCopy}
            isAddUser={isAddUser}
            company={company}
            tempUnCheckedRef={tempUnCheckedRef}
          />
        </Grid>
        <DialogBox open={openWindow || editWindow} dialogClose={handleWindowClose} title="Add Role">
          <AddWindow
            setWindowData={setWindowData}
            windowData={windowData}
            setOpenWindow={setOpenWindow}
            setEditWindow={setEditWindow}
            editWindow={editWindow}
            setWindowRowData={setWindowRowData}
            windowRowData={windowRowData}
          />
        </DialogBox>
      </div>
    </div>
  );
};

export default SearchRoleManagement;
